import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import { computed } from 'vue';
import { Currency, CurrencyNameMap, CurrencyList } from '@shared/types/currency';
import { useI18n } from 'vue-i18n';

interface Option {
  id: Currency;
  name: string;
}
interface Emits {
  (e: 'update:modelValue', value?: Currency): void;
}
interface Props {
  modelValue?: Currency;
  hideEmpty?: boolean;
  disabled?: boolean;
  small?: boolean;
  dropdownHeight?: number;
  errors?: string|string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencySelect',
  props: {
    modelValue: null,
    hideEmpty: { type: Boolean },
    disabled: { type: Boolean },
    small: { type: Boolean },
    dropdownHeight: null,
    errors: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value?: Currency): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: Currency;
  hideEmpty?: boolean;
  disabled?: boolean;
  small?: boolean;
  dropdownHeight?: number;
  errors?: string|string[];
}

const { t } = useI18n();

const currencies: Option[] = CurrencyList.map((id) => ({
  id,
  name: t(`common.currency.${CurrencyNameMap[id]}`),
}));





function updateValue(option?: Option) {
  emit('update:modelValue', option?.id);
}
const selected = computed<Option | undefined>(() => {
  if (props.modelValue) {
    return currencies.find(({id}) => id === props.modelValue) as Option;
  }
  return undefined;
});
const selectManager = useSelectClientDataManager({
  data: computed(() => currencies),
  selected,
  hideSelected: true,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SingleSelect), {
    "data-manager": _unref(selectManager),
    "model-value": _unref(selected),
    "onUpdate:modelValue": updateValue,
    "select-option-text": _ctx.$t('pages.common.select-currency'),
    "hide-empty": __props.hideEmpty,
    disabled: __props.disabled,
    small: __props.small,
    errors: __props.errors,
    "disable-search": "",
    "dropdown-height": __props.dropdownHeight
  }, null, 8, ["data-manager", "model-value", "select-option-text", "hide-empty", "disabled", "small", "errors", "dropdown-height"]))
}
}

})